// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDU8CS1ZuROCx7c-IVhnah29-dzKWDc0Q0",
  authDomain: "habbywebsite.firebaseapp.com",
  projectId: "habbywebsite",
  storageBucket: "habbywebsite.firebasestorage.app",
  messagingSenderId: "205641932237",
  appId: "1:205641932237:web:a0e837ac480a06b8c97884",
  measurementId: "G-K6YHLQPWN9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

export const signInWithGoogle = () => {
  return signInWithPopup(auth, provider);
};